import { postGoRelay, formatApi } from '../baseApi';
import { Message } from 'element-ui';

// 从nbroker获取数据，带url
export async function getDataByNbrokerUrl(
  params,
  url = 'http://ibroker-api:8080/nBroker/api/v1/task',
  path = '/ifob-fre',
  cache_expiration = 0
) {
  if (params.context.service_name === 'Db') {
    params.args.href = window.location.href;
  }
  const result = await postGoRelay(path, {
    Action: 'Nbroker',
    Method: 'UrlProxy',
    CacheExpiration: cache_expiration, // 后端缓存时间，单位秒
    NbrokerData: params,
    ServiceUrl: url,
  });

  const { data } = result;
  if (data.status !== 0) {
    Message.error(`转发到Nbroker接口出错 (Nbroker_UrlProxy)：${data.msg}`);
    throw new Error(data.msg);
  }

  return data;
}

export async function getTicketData(params) {
  const result = await formatApi({
    Action: 'QueryData',
    Method: 'Run',
    SchemaId: 'ticket_base',
    ReturnTotalRows: 1,
    Data: {
      ResultColumns: {
        CurrentAllProcessUsers: '',
        TicketId: '',
        TicketStatus: '',
      },
      SearchCondition: {
        TicketId: params,
      },
      Sorts: [],
      Limit: {
        Size: 20,
        Start: 0,
      },
    },
  });

  const { data } = result;
  if (data.status !== 0) {
    Toast.fail(`获取工单数据接口出错 (ticket_base)：${data.msg}`);
    throw new Error(data.msg);
  }

  return data;
}

export const getVariables = async (Keylist, InstanceId) => {
  const result = await formatApi({
    Action: 'Ticket', // 原样填写
    InstanceId, // (*必填) 流程实例Id
    Keylist,
    Method: 'GetHistoryVariables', // 原样填写
    SystemId: 2, // (*必填) (可取值区间为[>0]) (要求数据类型[int]) 调用方系统标识
  });

  const { data } = result;
  if (data.status !== 0) {
    Toast.fail(`获取接口出错：${data.msg}`);
    throw new Error(data.msg);
  } else {
    return data.data || {};
  }
};

/**
 * 根据工单号获取当前未完成待办的 task_id
 * @param {String} ticketId 工单号
 * @returns {Promise<String>} 未完成待办的 task_id，无待办返回 ''
 */
export async function getTaskIdByTicketId(ticketId) {
  const result = await formatApi({
    Action: 'QueryData',
    Method: 'Run',
    SchemaId: 'task_center_todo_runtime_aggs',
    ReturnTotalRows: 1,
    Data: {
      ResultColumns: {
        TicketId: '',
        TodoList: '',
      },
      SearchCondition: {
        TicketId: ticketId,
      },
      Sorts: [],
      Limit: {
        Size: 1,
      },
    },
  });

  const { data } = result;
  if (data.status !== 0) {
    Message.error(`获取工单待办task_id接口出错：${data.msg}`);
    throw new Error(data.msg);
  }

  const [row] = data.data?.List || [];
  if (!row) return '';
  const todoList = row.TodoList || [];
  return todoList.length ? todoList[0].TaskId || '' : '';
}
